import { defineMessages } from 'react-intl';

export default defineMessages({
    describeOther: {
        id: "quoteandbind.pa.directives.templates.insurance-history-prior-policies.Describe Other",
        defaultMessage: "Describe Other"
    },
});
